import { nameof } from "../components/Global/Utils";
import { ModuleStatuses, ModuleTypeId } from "../types/DBTables";
import { IModuleKylaVattenburetConfig, IModuleKylmaskin, IModuleVärmePrimärFjärrConfig, IModuleVärmePrimärPumpConfig } from "../types/ModuleDatas";
import { DTOBuilding, DTOModule } from "../types/building";
import { IRoundModuleResult } from "./roundHandler";

class ConfigurationHandler {
  public fixFormData(building: DTOBuilding, mt: ModuleTypeId, data: any): any {
    let d: any;
    let id: any;
    let idArr: any[];
    let m: DTOModule | undefined;

    switch (mt) {
      case ModuleTypeId.KylaMaskin:
        //TODO: om data är tom så skall map inte köras
        d = { ...data };
        idArr = [];
        data["frmData"].map((value: boolean, index: number) => (value ? idArr.push(index) : undefined));
        d[nameof<IModuleKylmaskin>("betjänadeSystem")] = idArr;
        delete d["frmData"];
        return d;
      case ModuleTypeId.KylaVattenburet:
        const moduleData = { ...data } as IModuleKylaVattenburetConfig;
        moduleData.värmeSystemGemensamBetjäningsyta = []; //värmeModulId: number; ytaAndel: number;
        Object.entries(data.frmData).forEach(([k, v]) => {
          const entry = v as any;
          if (entry.active) {
            moduleData.värmeSystemGemensamBetjäningsyta.push({ värmeModulId: entry.id, ytaAndel: entry.ytaAndel });
          }
        });
        delete (moduleData as any).frmData;
        return moduleData;
      default:
        return data;
    }
  }

  public getModuleFormData(building: DTOBuilding, module: DTOModule): any {
    let moduleData;

    //Module data is not empty. Potentially need to transform data for form
    if (module?.data && module?.data !== "{}") {
      moduleData = JSON.parse(module.data);
      switch (module.moduleTypeId) {
        case ModuleTypeId.KylaMaskin:
          let idArr: any[];
          moduleData = JSON.parse(module.data || "{}") as IModuleKylmaskin;
          const ksIds = moduleData.betjänadeSystem ? moduleData.betjänadeSystem : [];
          const frmData = [] as any[];
          ksIds.forEach((id) => {
            frmData[id] = true;
          });
          return { frmData: frmData };
        default:
          return moduleData;
      }
    }
    //Module data is empty. Set default values
    else {
      switch (module.moduleTypeId) {
        case ModuleTypeId.VarmePrimarFjarr:
          const configuredVP = building.modules.find((m) => m.moduleTypeId === ModuleTypeId.VarmePrimarFjarr && m.status === ModuleStatuses.Configured);
          if (configuredVP) {
            const data = JSON.parse(configuredVP.data);
            return {
              [nameof<IModuleVärmePrimärFjärrConfig>("harFlödestaxa")]: data[nameof<IModuleVärmePrimärFjärrConfig>("harFlödestaxa")],
            };
          }
          return {};

        default:
          return {};
      }
    }
  }
}

export const configurationHandler = new ConfigurationHandler();
